import { createStore } from 'vuex'

const store = createStore({
    state() {
        return{ 
            name: "",
            roomId: "",
            socket: null,
            players: 0,
            host: false,
            times: []
        }
    },
    mutations: {
        updateName(state, payload){
            state.name = payload.name
        },
        changeId(state, payload){
            state.roomId = payload.roomId
        },
        SetSocket(state, payload){
            state.socket = payload.socket
        },
        addPlayer(state){
            state.players += 1
        },
        toggleHost(state){
            state.host = !state.host
        },
    }
})

export default store